import React, { useCallback, useRef, useState } from "react";
import {
  Typography,
  Stack,
  Button,
  Box,
  Accordion,
  AccordionDetails,
} from "@mui/material";
import Chips from "components/Chips";
import CustomAccordionSummary from "styles/customAccordionSummary";
import useGridResizeHook, {
  calculateGridHeight,
} from "hooks/useGridResizeHook";
import { ExpandMore } from "@mui/icons-material";

const contractOptions = [
  { label: "ALL", value: "ALL" },
  { label: "P/GTM", value: "P/GTM" },
  { label: "RTM", value: "RTM" },
  { label: "SRX", value: "SRX" },
];

const cabOptions = [
  { label: "ALL", value: "ALL" },
  { label: "Q1", value: "Q1" },
  { label: "Q2", value: "Q2" },
  { label: "Q3", value: "Q3" },
  { label: "Q4", value: "Q4" },
];

const FiltersComponent = () => {
  const [selectedContract, setSelectedContract] = useState("ALL");
  const [selectedCab, setSelectedCab] = useState("ALL");
  const [expanded, setExpanded] = useState(false);

  const handleAccordionChange = () => {
    setExpanded((prev) => {
      const newExpanded = !prev;
      return newExpanded;
    });
  };

  return (
    <Box>
      <Accordion
        sx={{ padding: 0, margin: 0 }}
        expanded={expanded}
        onChange={handleAccordionChange}
      >
        <CustomAccordionSummary
          sx={{ padding: 0, margin: 0 }}
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Quick Filters:
          </Typography>
        </CustomAccordionSummary>
        <Stack direction="row" spacing={2} alignItems="center" mb={2}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            By Contract:
          </Typography>
          <Chips
            values={contractOptions}
            activeFilter={selectedContract}
            selectedFilter={(data) => setSelectedContract(data.value)}
          />
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" mb={2}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            By Last CAB:
          </Typography>
          <Chips
            values={cabOptions}
            activeFilter={selectedCab}
            selectedFilter={(data) => setSelectedCab(data.value)}
          />
        </Stack>
      </Accordion>
    </Box>
  );
};

export default FiltersComponent;
